.wb-logo-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  animation: fadeIn 0.5s linear;

  .logo-animation {
    height: 66px;
    width: 46px;
    overflow: hidden;
    position: relative;

    .fade-overlay {
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: 1;
      // NOTE: currently this comp will only work over an #FAFAFA bg,
      // but we can accept a diff bg color as prop and move this rule
      // to an inline style if necessary
      background: linear-gradient(
        #fafafa 10%,
        transparent 15%,
        transparent 85%,
        #fafafa 90%
      );
    }

    .columns {
      display: flex;
      gap: 8px;
      height: 46px;
      color: #b1b4b9;
      margin: 10px 0;
      .column-1 {
        animation: scrollColumn1 4s ease-in-out infinite;
      }
      .column-2 {
        animation: scrollColumn2 4s ease-in-out infinite;
      }
      .column-3 {
        animation: scrollColumn3 4s ease-in-out infinite;
      }
    }
  }

  .loading-texts {
    color: #79808a;
    font-weight: 600;
    white-space: nowrap;
    text-align: center;
    .text-carousel {
      animation: changeText 4s linear infinite;
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes scrollColumn1 {
  0%,
  15% {
    transform: translateY(0);
  }
  85%,
  100% {
    transform: translateY(calc(-100% + 46.1px));
  }
}

@keyframes scrollColumn2 {
  0%,
  15% {
    transform: translateY(calc(-100% + 46.2px));
  }
  85%,
  100% {
    transform: translateY(2px);
  }
}

@keyframes scrollColumn3 {
  0%,
  15% {
    transform: translateY(0);
  }
  85%,
  100% {
    transform: translateY(calc(-100% + 49px));
  }
}

@keyframes changeText {
  0%,
  5% {
    opacity: 0;
  }
  10%,
  90% {
    opacity: 1;
  }
  95%,
  100% {
    opacity: 0;
  }
}
